import { QueryClient } from 'react-query';

export const restartComputeEngine = async (
  queryClient: QueryClient,
  projectId: string
) => {
  await queryClient.invalidateQueries(['projectToken', { projectId }]);
  await queryClient.invalidateQueries(['computeUrl', { projectId }]);
};
